// Hamza Rajput Portfolio Data

export const personalInfo = {
  name: "Hamza Rajput",
  title: "Committed to the Bits and Bytes!",
  taglines: [
    "Full Stack Developer",
    "DevOps Engineer",
    "Cybersecurity Specialist",
    "Digital Marketing Expert"
  ],
  tagline: "Full Stack Developer | DevOps Engineer | Cybersecurity Specialist | Digital Marketing Expert",
  email: "hamzarajput.dev@gmail.com",
  phone: "+92 3097794699",
  location: "Lahore, Pakistan",
  image: "/hamza-image.png",
  bio: "Dynamic Freelancer specializing in digital marketing, Web Development, DevOps, and Innovating Solutions. Skilled in driving customer engagement through SEO campaigns, social media marketing, and website management. A tech enthusiast with expertise in software development (MERN stack, Java, Kotlin, Python), cybersecurity automation, VPS and hosting management, CI/CD pipelines, GitHub Actions, deployment automations, and cloud technologies. Experienced in building scalable applications, including ERP systems and AI-driven projects, with hands-on knowledge of Cisco ASA, Kali Linux, infrastructure automation, and Agile methodologies. Passionate about delivering innovative, user-focused solutions and leveraging data-driven strategies to achieve measurable results in fast-paced environments."
};

export const technologies = [
  // Frontend Technologies
  { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", color: "#61DAFB" },
  { name: "React Native", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", color: "#61DAFB" },
  { name: "Next.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg", color: "#FFFFFF" },
  { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg", color: "#F7DF1E" },
  { name: "HTML5", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg", color: "#E34F26" },
  { name: "CSS3", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg", color: "#1572B6" },

  // Backend Technologies
  { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg", color: "#339933" },
  { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg", color: "#3776AB" },
  { name: "Java", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg", color: "#007396" },
  { name: "Spring Boot", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg", color: "#6DB33F" },
  { name: "C++", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg", color: "#00599C" },

  // Mobile & Desktop
  { name: "Android", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg", color: "#3DDC84" },
  { name: "Kotlin", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg", color: "#7F52FF" },

  // Databases
  { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg", color: "#47A248" },

  // DevOps & Infrastructure
  { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg", color: "#2496ED" },
  { name: "Kubernetes", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg", color: "#326CE5" },
  { name: "GitHub Actions", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg", color: "#181717" },
  //{ name: "Jenkins", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg", color: "#D24939" },
  { name: "Git", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg", color: "#F05032" },
  { name: "Linux", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg", color: "#FCC624" },
  { name: "Nginx", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg", color: "#009639" },
  { name: "Apache", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg", color: "#D22128" },

  // Cloud & Hosting
  { name: "AWS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg", color: "#FF9900" }, // Using Azure as AWS icon isn't available
  { name: "VPS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ubuntu/ubuntu-plain.svg", color: "#E95420" },

  // Security & Networking
  { name: "Kali Linux", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kalilinux/kalilinux-original.svg", color: "#557C94" },
  //{ name: "Cisco", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/debian/debian-original.svg", color: "#1BA0D7" }, // Using Debian as network icon

  // CMS & E-commerce
  { name: "WordPress", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-original.svg", color: "#21759B" },

  // CI/CD & Automation
  { name: "Terraform", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg", color: "#7B42BC" },
  //{ name: "Ansible", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ansible/ansible-original.svg", color: "#EE0000" }
];

export const experience = [
  {
    id: 1,
    company: "Ark Techno Solutions",
    role: "Senior Software Developer",
    period: "2024 - Present",
    type: "Remote - Full Time",
    description: "Working on diverse projects across multiple technologies including Android development and Desktop Software Development. Hands-on experience with Cloud and MERN based projects. Managing VPS servers, implementing CI/CD pipelines with GitHub Actions, automating deployments, and ensuring robust infrastructure security. Configured and maintained production environments with Docker, Nginx, and cloud services.",
    skills: ["Android", "Desktop Apps", "Cloud", "MERN", "VPS Management", "CI/CD", "DevOps", "Docker", "GitHub Actions"]
  },
  {
    id: 2,
    company: "Travel Company Canada",
    role: "Web Developer & SMM",
    period: "2024",
    type: "Contract",
    description: "Developed the company website and contributed to Social Media and SEO growth, significantly increasing daily leads for this Canadian-based company operating in Lahore. Managed hosting infrastructure, implemented automated deployment workflows, and ensured website security and performance optimization.",
    skills: ["Web Development", "SEO", "Social Media Marketing", "Hosting Management", "Deployment Automation"]
  },
  {
    id: 3,
    company: "Immaculate Limo NY",
    role: "Team Lead",
    period: "2023 - 2024",
    type: "Leadership",
    description: "Led a team of 4 people, developed the company website and established online visibility. Gained hands-on experience with SEO, Digital Marketing, and Backlink creation strategies. Managed server infrastructure, implemented security measures, and automated deployment processes for improved efficiency.",
    skills: ["Team Leadership", "Web Development", "SEO", "Digital Marketing", "Server Management", "Security"]
  }
];

export const projects = [
  {
    id: 1,
    title: "ERP System Development",
    description: "Built scalable enterprise resource planning system with comprehensive modules for inventory, HR, and finance management. Implemented CI/CD pipelines, containerized with Docker, and deployed on managed VPS infrastructure.",
    tags: ["MERN", "Enterprise", "Cloud", "Docker", "CI/CD"],
    color: "#61DAFB"
  },
  {
    id: 2,
    title: "Android Applications",
    description: "Developed multiple Android applications using Kotlin and Java with modern Material Design principles. Automated build and deployment processes using GitHub Actions for seamless releases.",
    tags: ["Android", "Kotlin", "Java", "GitHub Actions"],
    color: "#3DDC84"
  },
  {
    id: 3,
    title: "AI-Driven Solutions",
    description: "Created AI and Machine Learning projects focused on automation and intelligent data processing. Deployed on cloud infrastructure with automated scaling and monitoring.",
    tags: ["Python", "AI/ML", "Automation", "Cloud"],
    color: "#7F52FF"
  },
  {
    id: 4,
    title: "VPS & Infrastructure Management",
    description: "Managed multiple VPS servers for various clients, implementing security hardening, automated backups, Nginx reverse proxy configurations, SSL certificates, and monitoring solutions.",
    tags: ["VPS", "Linux", "Nginx", "Security", "DevOps"],
    color: "#2496ED"
  },
  {
    id: 5,
    title: "CI/CD Pipeline Automation",
    description: "Designed and implemented comprehensive CI/CD pipelines using GitHub Actions and Jenkins. Automated testing, building, and deployment processes for multiple projects, reducing deployment time by 80%.",
    tags: ["GitHub Actions", "Jenkins", "CI/CD", "Automation", "DevOps"],
    color: "#D24939"
  },
  {
    id: 6,
    title: "Cybersecurity & Penetration Testing",
    description: "Performed penetration testing and security audits using Kali Linux and industry-standard tools. Implemented security hardening for servers, configured firewalls (Cisco ASA), and established security monitoring systems.",
    tags: ["Kali Linux", "Security", "Pentesting", "Cisco ASA"],
    color: "#E34F26"
  },
  {
    id: 7,
    title: "Dockerized Application Deployments",
    description: "Containerized multiple applications using Docker and orchestrated with Docker Compose. Managed containerized environments on VPS and cloud platforms for improved scalability and deployment efficiency.",
    tags: ["Docker", "Containerization", "DevOps", "VPS"],
    color: "#2496ED"
  },
  {
    id: 8,
    title: "Automated Deployment Systems",
    description: "Built automated deployment systems for web applications, implementing zero-downtime deployments, automated rollbacks, and health checks. Integrated with GitHub webhooks for instant deployments.",
    tags: ["Deployment", "Automation", "GitHub", "DevOps"],
    color: "#181717"
  },
  {
    id: 9,
    title: "E-Commerce Platforms",
    description: "Developed WordPress and Shopify based e-commerce solutions with custom integrations. Managed hosting infrastructure, implemented CDN, caching strategies, and automated backup systems.",
    tags: ["WordPress", "Shopify", "E-Commerce", "Hosting"],
    color: "#21759B"
  },
  {
    id: 10,
    title: "Infrastructure as Code",
    description: "Implemented Infrastructure as Code using Terraform and Ansible for automated server provisioning, configuration management, and infrastructure deployment across multiple environments.",
    tags: ["Terraform", "Ansible", "IaC", "DevOps"],
    color: "#7B42BC"
  }
];

export const education = [
  {
    degree: "BS Computer Science",
    institution: "Virtual University",
    period: "Ongoing",
    status: "current"
  },
  {
    degree: "Web Development Diploma",
    institution: "Aptech Technical Training",
    period: "2021 - 2022",
    status: "completed"
  },
  {
    degree: "Intermediate in Computer Science",
    institution: "Punjab College",
    period: "2018 - 2020",
    status: "completed"
  }
];

export const skills = {
  development: [
    "Android App Development",
    "React Native Development",
    "Desktop Software Development",
    "MERN Stack",
    "Full Stack Development",
    "AI/Machine Learning",
    "WordPress/Shopify"
  ],
  devops: [
    "VPS & Server Management",
    "Cloud Infrastructure (AWS)",
    "Docker & Containerization",
    "Kubernetes Orchestration",
    "CI/CD Pipelines (GitHub Actions, Jenkins)",
    "Deployment Automation",
    "GitHub Automations & Webhooks",
    "DevOps Practices",
    "Infrastructure as Code (Terraform, Ansible)",
    "Nginx & Apache Configuration",
    "Linux System Administration"
  ],
  security: [
    "Kali Linux Pentesting",
    "Cybersecurity & Security Hardening",
    "Cisco Networking & ASA Firewalls",
    "Security Auditing",
    "Penetration Testing"
  ],
  other: [
    "SEO & Digital Marketing",
    "Content Writing",
    "Video & Graphics Creation",
    "Technical Documentation"
  ],
  soft: [
    "Team Leadership",
    "Critical Thinking",
    "Agile Methodologies",
    "Project Management",
    "Problem Solving"
  ]
};

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Skills", href: "#skills" },
  { name: "Experience", href: "#experience" },
  { name: "Projects", href: "#projects" },
  { name: "Contact", href: "#contact" }
];
